import { render, staticRenderFns } from "./resources.cattle.io.backup.vue?vue&type=template&id=ee59b6c2&"
import script from "./resources.cattle.io.backup.vue?vue&type=script&lang=js&"
export * from "./resources.cattle.io.backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports